import { render, staticRenderFns } from "./GiftView.vue?vue&type=template&id=fbfd864c"
import script from "./GiftView.vue?vue&type=script&lang=js"
export * from "./GiftView.vue?vue&type=script&lang=js"
import style0 from "./GiftView.vue?vue&type=style&index=0&id=fbfd864c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports